export class PremiumUserRequirementNotMetError extends Error {
  constructor(message: string = 'Premium user requirement not met') {
    super(message);
    this.name = 'PremiumUserRequirementNotMetError';
  }
}

export class OcrUpsellRequiredError extends PremiumUserRequirementNotMetError {
  constructor(message: string = 'OCR upsell required for image-only PDF') {
    super(message);
    this.name = 'OcrUpsellRequiredError';
  }
}
